var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12.7 12.7" },
    },
    [
      _c("title", [_vm._v("thermal")]),
      _c("g", { attrs: { id: "Geothermal" } }, [
        _c("path", {
          staticClass: "cls-1",
          attrs: {
            d: "M 7.3677264,0.92792642 4.1050173,5.3280939 6.0806028,5.358027 5.1526762,8.4710706 8.5051848,4.011037 H 6.3799339 Z",
          },
        }),
        _c("path", {
          staticClass: "cls-1",
          attrs: {
            d: "M 1.6713625,10.416723 V 4.9688966 c 0,0 0.02245,-0.5687292 0.6585284,-0.5687292 H 4.1386981 L 3.7495677,4.9165136 H 2.3598239 c 0,0 -0.1945651,0.014968 -0.1945651,0.1945654 v 5.253261",
          },
        }),
        _c("path", {
          staticClass: "cls-1",
          attrs: {
            d: "M 11.028638,10.416723 V 4.9688966 c 0,0 -0.02245,-0.5687292 -0.658528,-0.5687292 H 8.8755999 L 8.4715027,4.9165136 h 1.8686733 c 0,0 0.194566,0.014968 0.194566,0.1945654 v 5.253261",
          },
        }),
        _c("path", {
          staticClass: "cls-2",
          attrs: {
            d: "M 0.6136288,11.449415 V 8.2914719 H 1.1673914 V 10.82082 H 2.6939801 V 8.2615388 L 4.6535354,8.2765063 4.4739365,8.8003358 H 5.5825254 L 5.9657651,8.292082 h 4.0917599 v 2.558672 h 1.541556 V 8.3214058 h 0.523829 v 3.0980772 z",
          },
        }),
        _c("path", {
          staticClass: "cls-2",
          attrs: {
            d: "M 2.6790134,7.9023415 V 6.2260873 l 2.6939801,0 -0.5537624,1.6612876 z",
          },
        }),
        _c("path", {
          staticClass: "cls-2",
          attrs: {
            d: "M 6.2859534,7.9023415 7.4832779,6.2260873 h 2.6041811 l -0.01497,1.6612876 z",
          },
        }),
        _c("path", {
          staticClass: "cls-2",
          attrs: {
            d: "M 0.61266026,7.9033098 V 6.2251187 H 1.1683089 l 0.015017,1.6781921 z",
          },
        }),
        _c("path", {
          staticClass: "cls-2",
          attrs: {
            d: "M 11.553211,7.9033098 V 6.2251187 h 0.555648 l 0.01502,1.6781921 z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }